<input type="hidden" v-model="model">